"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import Implementation from "./components/implementation";

const PrivateK8ClustersPage = () => {
  return (
    <>
      <PageLayout>
        <Hero />
        <PrivateCloudTabs />
        <Intro />
        <FeaturesComponent />
      </PageLayout>
      <Implementation />
      <PageLayout showContactForm>
        <Faqs />
      </PageLayout>
    </>
  );
};

export default PrivateK8ClustersPage;
